import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useEffect, useState } from "react";
import('./cg.css').then(() => {});

export default function CG() {
  const [content, setContent] = useState("");
  const [headings, setHeadings] = useState([]);

  const slugify = (text) =>
  text
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // enlève accents
    .replace(/[^\w\s-]/g, "") // enlève caractères spéciaux
    .trim()
    .replace(/\s+/g, "-");

  useEffect(() => {
    fetch("/CGU.md")
      .then(res => res.text())
      .then(text => {
        setContent(text);
        console.log("CGU content loaded:", text);
        const lines = text.split("\n");
        const extracted = lines
          .filter(line => /^##\s/.test(line))
          .map(line => {
            const title = line.replace(/^##\s/, "");
            const id = title.toLowerCase().replace(/\s+/g, "-");
            return { title, id: slugify(title) };
          });
        setHeadings(extracted);
      });
  }, []);

  return (
    <div className="layout" style={{}}>
      
      {/* Sommaire 
      <nav className="toc">
        <h3>Sommaire</h3>
        <ul>
          {headings.map(h => (
            <li key={h.id}>
              <a href={`#${h.id}`}>{h.title}</a>
            </li>
          ))}
        </ul>
      </nav>
      */}
      {/* Contenu */}
      <div className="content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h2: ({ children }) => {
              const text = children.toString();
              return <h2 id={slugify(text)}>{children}</h2>;
            }
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
}